<template>
  <div class="mt-2">
    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title">Profile Information</h5>
        <p><strong>Username:</strong> {{ username }}</p>
        <p><strong>Email:</strong> {{ email }}</p>
        <p><strong>Status:</strong> {{ isSuperuser ? 'Superuser' : 'User' }}</p>

        <button class="btn btn-primary btn-sm me-2" @click="showEdit = !showEdit">
          {{ showEdit ? 'Cancel Edit' : 'Edit Profile' }}
        </button>
        <button class="btn btn-primary btn-sm" @click="showPassword = !showPassword">
          {{ showPassword ? 'Cancel Password Change' : 'Change Password' }}
        </button>
      </div>
    </div>

    <form v-if="showEdit || showPassword" @submit.prevent="updateProfile">
      <div v-if="showEdit" class="card mb-4">
        <div class="card-body">
          <h5 class="card-title">Edit Profile</h5>

          <div class="mb-3">
            <label class="form-label">New Username</label>
            <input v-model="form.newUsername" type="text" class="form-control" />
          </div>

          <div class="mb-3">
            <label class="form-label">New Email</label>
            <input v-model="form.newEmail" type="email" class="form-control" />
          </div>
        </div>
      </div>

      <div v-if="showPassword" class="card mb-4">
        <div class="card-body">
          <h5 class="card-title">Change Password</h5>

          <div class="mb-3">
            <label class="form-label">New Password</label>
            <input v-model="form.newPassword" type="password" class="form-control" />
          </div>

          <div class="mb-3">
            <label class="form-label">Confirm New Password</label>
            <input v-model="form.confirmPassword" type="password" class="form-control" />
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          <h5 class="card-title">Confirm Changes</h5>

          <div class="mb-3">
            <label class="form-label">Current Password</label>
            <input v-model="form.currentPassword" type="password" class="form-control" required />
          </div>

          <button type="submit" class="btn btn-primary">Save Changes</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import userService from '@/services/userService';
import emitter from "@/eventBus";

export default {
  data() {
    return {
      form: {
        username: this.$store.state.auth.user.username,
        email: this.$store.state.auth.user.email,
        newUsername: '',
        newEmail: '',
        newPassword: '',
        confirmPassword: '',
        currentPassword: '',
      },
      showEdit: false,
      showPassword: false,
    };
  },
  computed: {
    username() {
      return this.$store.state.auth.user.username;
    },
    email() {
      return this.$store.state.auth.user.email;
    },
    isSuperuser() {
      return this.$store.state?.auth?.user?.role === 'superuser';
    },
    userId() {
      return this.$store.state.auth.user.id;
    },
  },
  methods: {
    async updateProfile() {
      if (this.form.newPassword && this.form.newPassword !== this.form.confirmPassword) {
        alert('New password and confirmation do not match.');
        return;
      }

      const payload = {
        username: this.form.newUsername || this.form.username,
        email: this.form.newEmail || this.form.email,
        password: this.form.newPassword || null,
        currentPassword: this.form.currentPassword,
      };

      try {
        await userService.updateUser(payload);
        emitter.emit("show-toast", {
          message: `Profile updated successfully.`,
          type: "success",
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.showEdit = false;
        this.showPassword = false;
        this.form.currentPassword = '';
        this.form.newUsername = '';
        this.form.newEmail = '';
        this.form.newPassword = '';
        this.form.confirmPassword = '';
      }
    },
  },
};
</script>
